import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DoCheck,
  inject,
  OnInit,
} from '@angular/core';
import {
  DynamicContainerBaseComponent,
  DynamicEventBusTypes,
} from '@ups/xplat/dynamic-render';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ups-dynamic-container',
  styleUrls: ['dynamic-container.component.scss'],
  template: `
    <div class="dynamic-container">
      <div>
        @for (item of dynamicItems; track item) {
          <ng-container
            dynamicItem
            [config]="item"
            [group]="form"
          ></ng-container>
        }
      </div>
    </div>
  `,
  // WI 35909 (S3): every control dynamicItem creates here is OnPush (S1, S2). This view marks when the base swaps
  // its form on a total reset, and when a host changes the group's controls list without a new group.
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicContainerComponent
  extends DynamicContainerBaseComponent
  implements OnInit, DoCheck
{
  private readonly cdr = inject(ChangeDetectorRef);
  private controlsSeen: { controls: unknown; length: number } | undefined;

  override ngOnInit() {
    super.ngOnInit();
    // the base subscribed first, so its new form is already bound when this marks
    this.dynamicService.eventBus
      .observe(DynamicEventBusTypes.dynamicFormTotalReset)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.cdr.markForCheck());
  }

  ngDoCheck(): void {
    const controls = this.dynamicGroup?.controls;
    const length = controls?.length ?? 0;
    if (
      !this.controlsSeen ||
      this.controlsSeen.controls !== controls ||
      this.controlsSeen.length !== length
    ) {
      this.controlsSeen = { controls, length };
      this.cdr.markForCheck();
    }
  }
}
